import { Navigate, Outlet } from "react-router-dom";
import useAuth from "../../utils/hooks/useAuth";
import { useSelector } from "react-redux";

const AuthRoute = () => {
  const { slug } = useSelector((state) => state.base.common.currentStore);
  const { authenticated } = useAuth();

  if (authenticated) {
    return <Navigate to={slug ? `/${slug}` : "/home"} replace />;
  }

  return <Outlet />;
};

export default AuthRoute;
